import { geistSans } from "@/components/atoms/buttons/Button";
import NavLinkCounter from "@/components/atoms/navbar/nav-link-counter/NavLinkCounter";
import { cn } from "@/lib/utils";
import { HeartIcon, LayoutGrid, Lightbulb } from "lucide-react";
import Link from "next/link";

const iconMap = {
  LayoutGrid,
  Lightbulb,
  HeartIcon,
};

type IconName = keyof typeof iconMap;

type NavLinkProps = {
  navLink: {
    label: string;
    link: string;
  };
  icon?: IconName;
  count?: number;
};

const NavLink = ({ navLink, icon, count }: NavLinkProps) => {
  const Icon = icon ? iconMap[icon] : null;

  return (
    <li
      className={cn(
        "flex items-center gap-2.5 antialiased transition-all duration-150 ease-in-out hover:scale-[102%] hover:text-black",
        geistSans.className
      )}
    >
      {Icon && <Icon size={20} />}
      <Link href={navLink.link || "/"} className="font-cabinet-grotesk font-medium whitespace-nowrap">
        {navLink.label}
      </Link>
      {typeof count === "number" && <NavLinkCounter count={count} />}
    </li>
  );
};

export default NavLink;
